module.exports = __webpack_public_path__ + "static/media/CenturyGothic.d726aa94.eot";